import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import {
  BottomNavigation,
  BottomNavigationAction,
  IconButton,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import InfoIcon from '@material-ui/icons/Info'
import TaskIcon from '@material-ui/icons/Done'
import { CalendarCheck } from 'mdi-material-ui'
import {
  toggleBottomNav,
  clickBottomNavigation,
} from 'actions/campaign/addOrEdit'

export default connect(
  state => ({
    bottomNavigation: state.campaign.addOrEdit.bottomNavigation.index,
    navDisplayed: state.campaign.addOrEdit.bottomNavigation.displayed,
    funnelCalendarView: state.campaign.addOrEdit.funnelCalendarView,
  }),
  dispatch =>
    bindActionCreators({ toggleBottomNav, clickBottomNavigation }, dispatch),
)(
  withStyles(theme => ({
    bottomNav: {
      position: 'fixed',
      bottom: 0,
      backgroundColor: theme.palette.secondary.main,
      color: '#fff',
      width: '100%',
      boxShadow: '0 -16px 5px -2px rgba(0,0,0,0.12)',
      zIndex: 3,
      left: 0,
    },
    bottomNavActionSelected: {
      color: '#fff !important',
      backgroundColor: '#003a71',
      fontSize: '0.75rem !important',
      paddingTop: '0 !important',
    },
    bottomNavLabel: {
      color: '#fff',
    },
  }))(
    ({
      bottomNavigation,
      navDisplayed,
      classes,
      toggleBottomNav,
      clickBottomNavigation,
      funnelCalendarView,
    }) => {
      return (
        <BottomNavigation
          className={classes.bottomNav}
          onChange={(e, val) => {
            e.stopPropagation()
            toggleBottomNav(true)
            clickBottomNavigation(val)
          }}
          value={bottomNavigation}
        >
          <IconButton
            disableRipple
            disableTouchRipple
            onClick={() => toggleBottomNav()}
          >
            {navDisplayed ? (
              <ExpandMoreIcon style={{ color: '#fff' }} />
            ) : (
              <ExpandLessIcon style={{ color: '#fff' }} />
            )}
          </IconButton>
          <BottomNavigationAction
            classes={{
              selected: classes.bottomNavActionSelected,
              label: classes.bottomNavLabel,
            }}
            label="General"
            icon={<InfoIcon style={{ color: '#fff' }} />}
            showLabel
          />
          {funnelCalendarView === 'funnel' ? (
            <BottomNavigationAction
              classes={{
                selected: classes.bottomNavActionSelected,
                label: classes.bottomNavLabel,
              }}
              label="Event Goals"
              icon={<CalendarCheck style={{ color: '#fff' }} />}
              showLabel
            />
          ) : null}
          <BottomNavigationAction
            classes={{
              selected: classes.bottomNavActionSelected,
              label: classes.bottomNavLabel,
            }}
            label="Tasks"
            icon={<TaskIcon style={{ color: '#fff' }} />}
            showLabel
          />
        </BottomNavigation>
      )
    },
  ),
)
